import type { Request } from '@/lib/dd-queue/types'
import type { SubjectMutation } from '@/lib/dd-queue/types/subjectMutation'
import { resolveSubject, type ResolvedSubject } from '@/lib/dd-queue/resolveSubject'

export interface SelectedLine {
  req: Request
  sku: string
  resolved: ResolvedSubject
}

/** Flatten visible rows to bulk-select keys (reference QueueTable.tsx L35–37). */
export function visibleSelectKeys(requests: Request[]): string[] {
  return requests.flatMap((r) =>
    r.isMaster ? r.children.map((c) => `${r.id}:${c.sku}`) : [r.id]
  )
}

/** Resolve selected lines for BulkBar actions (reference BulkBar.tsx L21–40). */
export function selectedLinesOf(
  allRequests: Request[],
  selectedBulk: Record<string, true>,
  mutations: Record<string, SubjectMutation>
): SelectedLine[] {
  const out: SelectedLine[] = []
  for (const r of allRequests) {
    if (r.isMaster) {
      for (const c of r.children) {
        if (!selectedBulk[`${r.id}:${c.sku}`]) continue
        const resolved = resolveSubject(r, c.sku, mutations)
        if (resolved && resolved.deletedAt == null) {
          out.push({ req: r, sku: c.sku, resolved })
        }
      }
    } else {
      if (!selectedBulk[r.id]) continue
      const resolved = resolveSubject(r, r.sku, mutations)
      if (resolved && resolved.deletedAt == null) {
        out.push({ req: r, sku: r.sku, resolved })
      }
    }
  }
  return out
}

export function arrayMove<T>(arr: T[], from: number, to: number): T[] {
  const next = [...arr]
  const [item] = next.splice(from, 1)
  next.splice(to, 0, item!)
  return next
}
